/* Home banner: swipe left or right to change the photo (Josh, 2026-10-17, phones). The banner
   cycles on CSS keyframes (heroSlide2/3, 21s, three 7s photos over a still first one). The first
   swipe takes the loop over: the keyframes stop, each overlay fades on its own opacity over the
   same second the loop uses, and a timer keeps changing photos every 7s from where the swipe
   left it. Photo 0 is the still image underneath; photos 1 and 2 are the overlays. */
(function () {
  var hero = document.querySelector('.hero');
  if (!hero) return;
  var slides = hero.querySelectorAll('img.hero-slide');
  if (slides.length !== 2) return;
  var CYCLE = 21000, STEP = 7000;
  var i = 0, manual = false, timer = null, sx = null, sy = 0;
  function current() {
    var a = slides[0].getAnimations ? slides[0].getAnimations()[0] : null;
    if (!a || a.currentTime == null) return 0;
    var t = a.currentTime % CYCLE;
    return t < 7500 ? 0 : t < 14500 ? 1 : t < 20500 ? 2 : 0;
  }
  function show(k) {
    i = (k + 3) % 3;
    /* the upper photo covers the lower, so photo 1 stays up under photo 2 while it fades in */
    slides[0].style.opacity = i >= 1 ? '1' : '0';
    slides[1].style.opacity = i === 2 ? '1' : '0';
    clearTimeout(timer);
    timer = setTimeout(function () { show(i + 1); }, STEP);
  }
  function go(dir) {
    if (!manual) {
      var k = current();
      manual = true;
      hero.classList.add('is-manual');
      slides[0].style.opacity = k >= 1 ? '1' : '0';
      slides[1].style.opacity = k === 2 ? '1' : '0';
      void hero.offsetWidth;
      i = k;
    }
    show(i + dir);
  }
  hero.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
  hero.addEventListener('touchend', function (e) {
    if (sx === null) return;
    var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; sx = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) go(dx < 0 ? 1 : -1);
  }, { passive: true });
})();
